import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvailabilityFormComponent } from './availability-form.component';
import { AngularMaterialModule } from '../../angular-material/angular-material.module';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { InlineSVGModule } from "ng-inline-svg";



@NgModule({
  declarations: [AvailabilityFormComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule, ReactiveFormsModule,
    InlineSVGModule
  ],
  exports:[AvailabilityFormComponent]
})
export class AvailabilityFormModule { }
